import { Flex, Heading, Text } from '@sine/sine-ui-components';
import { NoSites } from '@sine/sine-ui-components/illustrations';

export function NoSitesSplash() {
  return (
    <Flex direction='column' alignItems='center' gap={4}>
      <NoSites />
      <Heading type='h3'>No available sites</Heading>
      <Text>Please create a site and try again.</Text>
    </Flex>
  );
}
